import {
  DoctorInactiveNoteListAPIRes,
  DOCTOR_INACTIVE_NOTE_LIST_FAIL,
  DOCTOR_INACTIVE_NOTE_LIST_LOADING,
  DOCTOR_INACTIVE_NOTE_LIST_SUCCESS,
  DoctorInactiveNoteListState,
  DOCTOR_INACTIVE_NOTE_LIST_API_MSG,
  DOCTOR_INACTIVE_NOTE_LIST_API_RES,
} from "./ActionTypes";
import { DoctorInactiveListResponse } from "./Model";

const initialStateEditPosts: DoctorInactiveNoteListState = {
  loading: false,
  doctorInactiveNoteListRes: {} as DoctorInactiveListResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const doctorInactiveNoteListReducer = (
  state = initialStateEditPosts,
  action: DoctorInactiveNoteListAPIRes
): DoctorInactiveNoteListState => {
  switch (action.type) {
    case DOCTOR_INACTIVE_NOTE_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DOCTOR_INACTIVE_NOTE_LIST_SUCCESS:
      return {
        ...state,
        doctorInactiveNoteListRes: action.payload,
        successMsg: action.successMsg,
      };
    case DOCTOR_INACTIVE_NOTE_LIST_FAIL:
      return {
        ...state,
        doctorInactiveNoteListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_INACTIVE_NOTE_LIST_API_MSG:
      return {
        ...state,
        doctorInactiveNoteListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_INACTIVE_NOTE_LIST_API_RES:
      return {
        ...state,
        doctorInactiveNoteListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};